import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 26 25",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m1.568 18.539-.53-.53a1.125 1.125 0 0 1 0-1.591L12.971 4.485l-1.591-1.59c-.709-.709-.204-1.921.795-1.921h5.303c.622 0 1.125.503 1.125 1.125v5.303c0 .995-1.209 1.507-1.92.796l-1.591-1.591L3.159 18.539c-.439.44-1.151.44-1.59 0ZM22.782 7.402 10.849 19.334l-1.59-1.59c-.707-.707-1.921-.207-1.921.795v5.303c0 .622.503 1.125 1.125 1.125h5.303c.996 0 1.506-1.21.796-1.92l-1.591-1.591L24.903 9.523c.44-.439.44-1.151 0-1.59l-.53-.53a1.125 1.125 0 0 0-1.591 0Z" }, null, -1)
  ]))]))
}
export default { render: render }